import { LocalizationProvider, TimeField } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { ruRU } from '@mui/x-date-pickers/locales'
import dayjs from 'dayjs'
import { Controller, FieldError, useFormContext } from 'react-hook-form'
import { DatePicker } from 'ui'

type TOrderManageFormDateTime = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleTimeFieldChange: (...time: any[]) => void
  handlePickerChange: (newDate: Date) => void
}

// тайм слот для формы переноса даты заявки

export const OrderManageFormDateTime = ({
  handleTimeFieldChange,
  handlePickerChange,
}: TOrderManageFormDateTime) => {
  const { control } = useFormContext()

  const checkIsFieldError = (error: FieldError | undefined) => {
    return error && !!Object.keys(error).length
  }

  const today = dayjs()
  const yearLatter = dayjs().add(1, 'year')

  return (
    <>
      <LocalizationProvider
        dateAdapter={AdapterDayjs}
        adapterLocale='ru'
        localeText={
          ruRU.components.MuiLocalizationProvider.defaultProps.localeText
        }
      >
        <Controller
          name='date'
          control={control}
          render={({ field: { onChange, ...restField }, fieldState }) => (
            <DatePicker
              yearsPerRow={3}
              slotProps={{
                field: { clearable: true },
                actionBar: {
                  actions: ['today', 'clear'],
                },
                textField: {
                  required: true,
                  error: checkIsFieldError(fieldState.error),
                },
              }}
              onChange={handlePickerChange}
              views={['year', 'month', 'day']}
              minDate={today}
              maxDate={yearLatter}
              label='Дата'
              {...restField}
            />
          )}
        />
      </LocalizationProvider>
      <LocalizationProvider
        dateAdapter={AdapterDayjs}
        adapterLocale='ru'
        localeText={
          ruRU.components.MuiLocalizationProvider.defaultProps.localeText
        }
      >
        <Controller
          name='time'
          control={control}
          render={({ field: { onChange, ...restField }, fieldState }) => (
            <TimeField
              // className={style.timePicker}
              label='Время *'
              inputProps={{
                required: true,
                error: checkIsFieldError(fieldState.error),
              }}
              onChange={handleTimeFieldChange}
              {...restField}
            />
          )}
        />
      </LocalizationProvider>
    </>
  )
}
